import React from 'react';
import PropTypes from 'prop-types';
import { plainTerm, sourceHost, tileText } from './linksPuzzles';
import './links.css';

const fmt = (value) => (typeof value === 'number' ? value.toFixed(2) : '–');


// The 16 tiles as the four solved groups (upper case as in the app, soft
// hyphens shown as ·), with each term's gloss and, when
// the judge scored the board, its prominence / fit / difficulty / red herring.
// An off-course term (hard only) is marked, with the page that confirmed it;
// the page outlives an edit, the numbers do not.
export default function LinksBoard({ groups, termScores }) {
    return (
        <div className="lk-board">
            {groups.map((group, gi) => (
                <div className={`lk-group lk-group-${gi}`} key={`${group.course_id}-${gi}`}>
                    <div className="lk-group-head">
                        <span className="lk-theme">{group.theme}</span>
                        <span className="lk-course">{group.course_name} · #{group.course_id}</span>
                    </div>
                    <ul className="lk-terms">
                        {group.terms.map((t) => {
                            const s = termScores?.[plainTerm(t.term)];
                            return (
                                <li key={t.term}>
                                    <span className="lk-tile">{tileText(t.term)}</span>
                                    <span className="lk-gloss">{t.gloss}</span>
                                    {s?.source && (
                                        <a className="lk-source" href={s.source} target="_blank" rel="noopener noreferrer"
                                            title="Not in the course; confirmed by a web search">
                                            off-course · {sourceHost(s.source)}
                                        </a>
                                    )}
                                    {typeof s?.fit === 'number' && (
                                        <span className="lk-nums" title="prominence / fit / difficulty / red herring">
                                            {fmt(s.prominence)} / {fmt(s.fit)} / {fmt(s.difficulty)} / {fmt(s.red_herring)}
                                        </span>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    );
}

const termShape = PropTypes.shape({ term: PropTypes.string, gloss: PropTypes.string });
export const groupShape = PropTypes.shape({
    course_id: PropTypes.number,
    course_name: PropTypes.string,
    theme: PropTypes.string,
    terms: PropTypes.arrayOf(termShape),
});

LinksBoard.propTypes = {
    groups: PropTypes.arrayOf(groupShape).isRequired,
    termScores: PropTypes.objectOf(PropTypes.object),
};

LinksBoard.defaultProps = { termScores: null };
